import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import Live from "../layouts/live/Live";
import News from "../layouts/news/News";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../components/navbar/Navbar";
import NewProfile from "../components/userProfile/NewProfile";
import '../App.css';
import LoginPage from "../layouts/logInPage/LoginPage";
import PrivateRoute from "./PrivateRoute";
import Backoffice from "../layouts/backoffice/BackOffice";
// import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import moment from "moment";
import Historical from "../layouts/historical/Historical";
import { Suspense, useEffect} from "react";
import { login, logout } from '../store/authSlice'
import Sidebar from "../components/sidebar/Sidebar";
import Loading from "../components/userProfile/Loading";
import Portfolio from "../layouts/portfolio/Portfolio";
import Settings from "../components/settings/settings";
import { ToastContainer } from "react-toastify";
// import Portfolio from "../layouts/portfolio/Portfolio";


const FeedsenseRoutes = ({toast}:any) => {
    const dispatch = useDispatch()
    const loginSelector: any = useSelector((state: any) => state.auth.isLoggedIn);

    useEffect(() => {
        const userDetails: any = Cookies.get('details')
        let userDetailsCookies: any = userDetails ? JSON.parse(userDetails) : { 'isLoggedIn': false }
        // Check if user is logged in based on cookies
        const userIsLoggedIn: any = userDetailsCookies.isLoggedIn;

        if (userIsLoggedIn && !loginSelector) {
            // If user is logged in but Redux state doesn't reflect it, update Redux state
            dispatch(login());
        } else if (!userIsLoggedIn && loginSelector) {
            // If user is not logged in but Redux state reflects it, update Redux state
            dispatch(logout());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, loginSelector]);

    const userDetailsCookies: any = Cookies.get('details')
    const details: any = userDetailsCookies ? JSON.parse(userDetailsCookies) : { 'isLoggedIn': false }
    const currentDate: any = moment(new Date()).format("YYYY-MM-DD")
    const userExpiry: any = moment(new Date(details['expiry'])).format("YYYY-MM-DD")
    const toggle: any = useSelector((state: any) => state.sidebarToggle.isOpen);

    return (
        <>
            <Router>
                {loginSelector && <Navbar />}
                <div className="content">
                    {loginSelector && <Sidebar toggle={toggle} />}
                    <main>
                        <Routes>
                            <Route path="/" element={(loginSelector && (currentDate <= userExpiry)) ? <PrivateRoute > <Live /> </PrivateRoute> : <LoginPage />} />
                            <Route path="/live" element={<PrivateRoute > <Live /> </PrivateRoute>} />
                            <Route path="/historical/:type" element={<PrivateRoute  ><Historical /> </PrivateRoute>} />
                            <Route path="/news" element={<News />} />
                            <Route path="/backoffice" element={<PrivateRoute  ><Backoffice /> </PrivateRoute>} />
                            <Route path="/portfolio" element={<PrivateRoute  ><Portfolio /> </PrivateRoute>} />
                            <Route path="/settings" element={ <Settings /> } />
                            <Route path="/subscription" element={<PrivateRoute  ><Suspense fallback={<div style={{width:'100%', height:'100%', display:'flex',justifyContent:'center', alignItems:'center'}}><Loading/></div>}><NewProfile /></Suspense></PrivateRoute>} />
                            <Route path="*" element={<LoginPage />} />
                        </Routes>
                    </main>
                </div>
            </Router>
        </>
    )
}

export default FeedsenseRoutes;